import ArticleListMixin from '~/mixins/ArticleListMixin'
import CheckoutNextSteps from '~/themes/oknadverenamiru/components/cart/CheckoutNextSteps'
import HeaderConfigurationMixin from '~/mixins/HeaderConfigurationMixin'
import PageArticleList from '~/themes/base/components/content/PageArticleList'
import PageIntro from '~/themes/oknadverenamiru/components/shop/PageIntro'
import SeoMixin from '~/mixins/SeoMixin'

export default {
  extended: PageArticleList,
  components: {
    CheckoutNextSteps,
    PageIntro,
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('PageArticleList.breadcrumbs.index'),
          path: this.localePath({ name: 'articleList' }),
        },
      ],
      menuItems: null,
    }
  },
  head() {
    return this.getSeoHead({ yamlKey: 'PageArticleList' })
  },
  mixins: [ArticleListMixin, HeaderConfigurationMixin, SeoMixin],
}
